/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// Max range info popup
document.addEventListener('DOMContentLoaded', function() {
  const infoButtons = document.querySelectorAll('.product-form__option-name--info');
  
  infoButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.stopPropagation();
      
      let infoContent = this.nextElementSibling;
      if (!infoContent || !infoContent.classList.contains('product-form__option-name--info-content')) {
        infoContent = this.parentElement.querySelector('.product-form__option-name--info-content');
      }
      
      if (infoContent) {
        infoContent.style.display = 'block';
      }
    });
  });
  
  const closeButtons = document.querySelectorAll('.product-form__option-name--info-content--close');
  closeButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.stopPropagation();
      const infoContent = this.closest('.product-form__option-name--info-content');
      if (infoContent) {
        infoContent.style.display = 'none';
      }
    });
  });
  
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.product-form__option-name--info-content') && 
        !e.target.closest('.product-form__option-name--info')) {
      const infoContents = document.querySelectorAll('.product-form__option-name--info-content');
      infoContents.forEach(content => {
        content.style.display = 'none';
      });
    }
  });
  
  // Product gallery variant switcher
  function initializeProductGalleryVariants() {
    const galleryItems = document.querySelectorAll('gallery-item');
    
    galleryItems.forEach(item => {
      // Skip if already initialized
      if (item.dataset.variantListenersAttached === 'true') return;
      item.dataset.variantListenersAttached = 'true';
      
      const variantInputs = item.querySelectorAll('.variant-option-input');
      const variantsDataDiv = item.querySelector('[data-variants-data]');
      const priceContainer = item.querySelector('.products_gallery--item-price');
      const metafieldsContainer = item.querySelector('.variant-metafields');
      const detailedSpecsContainer = item.querySelector('.detailed-specs');
      const variantAccordion = item.querySelector('.variant-accordion');
      
      if (!variantsDataDiv) return;
      
      const variantsData = JSON.parse(variantsDataDiv.dataset.variantsData || '{}');
      const productId = variantsDataDiv.dataset.productId;
      
      function findVariantByOptions(selectedOptions) {
        for (const [variantId, variantData] of Object.entries(variantsData)) {
          if (JSON.stringify(variantData.options) === JSON.stringify(selectedOptions)) {
            return { id: variantId, ...variantData };
          }
        }
        return null;
      }
      
      function updatePriceDisplay(variant) {
      if (!priceContainer || !variant) return;
      
      const priceStr = variant.price;
      const compareAtPriceStr = variant.compare_at_price;
      
      let priceSpan = priceContainer.querySelector('.price:not(.price--compare)');
      let compareSpan = priceContainer.querySelector('.price--compare');
      
      if (compareAtPriceStr && compareAtPriceStr.trim() !== '') {
        const priceNum = parseFloat(priceStr.replace(/[^\d.,]/g, '').replace(/,/g, ''));
        const compareNum = parseFloat(compareAtPriceStr.replace(/[^\d.,]/g, '').replace(/,/g, ''));
        
        if (compareNum > priceNum) {
          if (!priceSpan || !priceSpan.classList.contains('price--sale')) {
            priceContainer.innerHTML = `
              <span class="price price--sale">${priceStr}</span>
              <span class="price price--compare">${compareAtPriceStr}</span>
            `;
          } else {
            priceSpan.textContent = priceStr;
            compareSpan.textContent = compareAtPriceStr;
          }
        } else {
          if (!priceSpan || priceContainer.querySelectorAll('.price').length > 1) {
            priceContainer.innerHTML = `<span class="price">${priceStr}</span>`;
          } else {
            priceSpan.textContent = priceStr;
          }
        }
      } else {
        if (!priceSpan || priceContainer.querySelectorAll('.price').length > 1) {
          priceContainer.innerHTML = `<span class="price">${priceStr}</span>`;
        } else {
          priceSpan.textContent = priceStr;
        }
      }
      }
      
      function updateMetafields(variant) {
        if (!metafieldsContainer || !variant) return;
        
        const metafields = ['steigfahigkeit', 'max_zuladung', 'peakleistung', 'gewicht'];
        metafields.forEach(field => {
          const metafieldItem = metafieldsContainer.querySelector(`[data-metafield="${field}"]`);
          if (metafieldItem) {
            const valueSpan = metafieldItem.querySelector('.metafield-value');
            if (variant[field]) {
              metafieldItem.style.display = '';
              if (valueSpan) {
                valueSpan.textContent = variant[field];
              }
            } else {
              metafieldItem.style.display = 'none';
            }
          }
        });
      }
      
      function updateDetailedSpecs(variant) {
        if (!detailedSpecsContainer || !variant) return;
        
        const specs = ['wattstunden_akku', 'ladezeit', 'federung_vorne', 'federung_hinten', 
                       'bremssystem_vorne', 'bremssystem_hinten', 'blinker', 'ip_schutzgrad'];
        specs.forEach(field => {
          const specItem = detailedSpecsContainer.querySelector(`[data-metafield="${field}"]`);
          if (specItem) {
            const valueSpan = specItem.querySelector('.spec-value');
            if (variant[field]) {
              specItem.style.display = '';
              if (valueSpan) {
                valueSpan.textContent = variant[field];
              }
            } else {
              specItem.style.display = 'none';
            }
          }
        });
      }
      
      function updateVariantDescription(variant) {
        if (!variantAccordion || !variant) return;
        
        const valueSpan = variantAccordion.querySelector('.metafield-value');
        if (variant.varianten_beschreibung) {
          variantAccordion.style.display = '';
          if (valueSpan) {
            valueSpan.textContent = variant.varianten_beschreibung;
          }
        } else {
          variantAccordion.style.display = 'none';
        }
      }
      
      function updateDeliveryLabel(variant) {
        let availableLabel = item.querySelector('.product_gallery--item-available');
        let outOfStockLabel = item.querySelector('.product_gallery--item-out-of-stock');
        const comingSoonLabel = item.querySelector('.product_gallery--item-coming-soon');
        const quickViewBtns = item.querySelectorAll('.product-gallery-quick-view-btn');
        
        if (!variant) return;
        
        // Use Shopify's translated strings instead of hardcoded German text
        var translations = {
          quickViewButton: window.themeVariables?.strings?.productFormAddToCart || 'Quick ansehen',
          outOfStockButton: window.themeVariables?.strings?.productFormSoldOut || 'Ausverkauft',
          outOfStock: window.themeVariables?.strings?.productFormUnavailable || 'Aktuell nicht lieferbar',
          preorderDefault: window.themeVariables?.strings?.productFormPreOrder || 'Lieferbar Ende November',
          addToCart: window.themeVariables?.strings?.productFormAddToCart || 'In den Warenkorb'
        };
        
        // Update quick view button text based on availability
        quickViewBtns.forEach(function(btn) {
          var btnText = btn.querySelector('.btn-text');
          if (btnText) {
           var currentAvailable = btn.getAttribute('data-available');
            var newAvailable = variant.available ? 'true' : 'false';

            // Only update if availability state changed
            if (currentAvailable !== newAvailable) {
              if (variant.available) {
                btnText.textContent = translations.addToCart;
                btn.setAttribute('data-available', 'true');
              } else {
                btnText.textContent = translations.outOfStockButton;
                btn.setAttribute('data-available', 'false');
              }
            }
          }
        });
        
        // Check if product is preorder (from data attribute) or variant has incoming date
        const productInfo = item.querySelector('.products_gallery--item-info');
        const isProductPreorder = productInfo && productInfo.dataset.isPreorder === 'true';
        const hasIncomingDate = variant.incoming_date_single && variant.incoming_date_single.trim() !== '';
        const isPreorder = isProductPreorder || hasIncomingDate;
        
        // Create available label if it doesn't exist (needed when initial variant was preorder)
        if (!availableLabel && (outOfStockLabel || comingSoonLabel)) {
          // TEMP (2026-07-28): using the inline "coming soon" SVG instead of Available.svg
          // for now. Old Available.svg/Soldout.svg icon-URL logic kept below, commented
          // out, so we can restore it later.
          //
          // var availableIconUrl = '';
          // // Try to find the icon from any available label on the page (including other products)
          // var existingAvailableImg = document.querySelector('.product_gallery--item-available img');
          // if (existingAvailableImg) {
          //   availableIconUrl = existingAvailableImg.src;
          // } else {
          //   // Try to find out of stock icon and replace with available
          //   var existingOutOfStockImg = document.querySelector('.product_gallery--item-out-of-stock img');
          //   if (existingOutOfStockImg) {
          //     availableIconUrl = existingOutOfStockImg.src.replace('Soldout.svg', 'Available.svg');
          //   }
          // }
          //
          // availableLabel = document.createElement('div');
          // availableLabel.className = 'product_gallery--item-available';
          // availableLabel.style.display = 'none';
          // if (availableIconUrl) {
          //   availableLabel.innerHTML = '<img src="' + availableIconUrl + '" style="width: 45px; height: auto;"><span class="dynamic-delivery-date available-value"></span>';
          // } else {
          //   availableLabel.innerHTML = '<span class="dynamic-delivery-date available-value"></span>';
          // }

          var productInfoEl = item.querySelector('.products_gallery--item-info');
          var availableIconUid = 'js-' + ((productInfoEl && productInfoEl.dataset.productId) || Date.now());
          var availableIconSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="132" height="100" viewBox="0 0 132 100" fill="none" style="vertical-align: middle; margin-right: 5px; width: 45px; height: auto;">
        <mask id="mask0_avail_${availableIconUid}" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="132" height="100">
        <path d="M132 0H0V100H132V0Z" fill="white"/>
        </mask>
        <g mask="url(#mask0_avail_${availableIconUid})">
        <mask id="mask1_avail_${availableIconUid}" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="1" y="20" width="91" height="67">
        <path d="M1.32291 20H92V86.6667H1.32291V20Z" fill="white"/>
        </mask>
        <g mask="url(#mask1_avail_${availableIconUid})">
        <path d="M89.6094 86.5573H36.0052C34.8437 86.5573 33.875 85.6146 33.875 84.4271C33.875 83.2396 34.8125 82.3021 36.0052 82.3021H87.4844V25.375H73.776C72.6146 25.375 71.651 24.4375 71.651 23.25C71.651 22.0625 72.5885 21.1198 73.776 21.1198H89.5833C90.7448 21.1198 91.7083 22.0625 91.7083 23.25V84.4271C91.7396 85.6146 90.7708 86.5573 89.6094 86.5573ZM12.1562 86.5573H3.45311C2.29166 86.5573 1.32291 85.6146 1.32291 84.4271V23.276C1.32291 22.1146 2.26041 21.151 3.45311 21.151H19.2552C20.4167 21.151 21.3854 22.0885 21.3854 23.276C21.3854 24.4635 20.4479 25.4062 19.2552 25.4062H5.57811V82.3281H12.1562C13.3177 82.3281 14.2812 83.2656 14.2812 84.4583C14.2812 85.6458 13.3437 86.5573 12.1562 86.5573Z" fill="#53535B"/>
        </g>
        <mask id="mask2_avail_${availableIconUid}" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="86" y="32" width="46" height="55">
        <path d="M86.6667 32H131.734V86.6667H86.6667V32Z" fill="white"/>
        </mask>
        <g mask="url(#mask2_avail_${availableIconUid})">
        <path d="M129.458 86.5573H120.755C119.594 86.5573 118.625 85.6146 118.625 84.4271C118.625 83.2396 119.562 82.3021 120.755 82.3021H127.328V55.6875C127.328 50.8802 124.818 46.1563 120.229 42.401C115.865 38.8073 110.141 36.6771 104.948 36.6771H89.6094C88.4479 36.6771 87.4844 35.7396 87.4844 34.5521C87.4844 33.3646 88.4219 32.4219 89.6094 32.4219H104.948C111.193 32.4219 117.74 34.8542 122.906 39.1094C128.49 43.6979 131.583 49.5833 131.583 55.6875V84.4271C131.583 85.6146 130.62 86.5573 129.458 86.5573ZM96.9062 86.5573H89.6094C88.4479 86.5573 87.4844 85.6146 87.4844 84.4271C87.4844 83.2396 88.4219 82.3021 89.6094 82.3021H96.9062C98.0677 82.3021 99.0312 83.2396 99.0312 84.4271C99.0312 85.6146 98.0937 86.5573 96.9062 86.5573Z" fill="#53535B"/>
        </g>
        <mask id="mask3_avail_${availableIconUid}" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="9" y="69" width="30" height="30">
        <path d="M9.33333 69.3333H38.6667V98.1771H9.33333V69.3333Z" fill="white"/>
        </mask>
        <g mask="url(#mask3_avail_${availableIconUid})">
        <path d="M24.0937 98.4948C16.3542 98.4948 10.0573 92.1927 10.0573 84.4584C10.0573 76.7188 16.3542 70.4167 24.0937 70.4167C31.8281 70.4167 38.1302 76.7188 38.1302 84.4584C38.1302 92.1927 31.8281 98.4948 24.0937 98.4948ZM24.0937 74.6459C18.6771 74.6459 14.2812 79.0417 14.2812 84.4584C14.2812 89.8698 18.6771 94.2656 24.0937 94.2656C29.5104 94.2656 33.901 89.8698 33.901 84.4584C33.901 79.0417 29.4792 74.6459 24.0937 74.6459Z" fill="#53535B"/>
        </g>
        <mask id="mask4_avail_${availableIconUid}" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="94" y="69" width="30" height="30">
        <path d="M94.6667 69.3333H124V98.1771H94.6667V69.3333Z" fill="white"/>
        </mask>
        <g mask="url(#mask4_avail_${availableIconUid})">
        <path d="M108.818 98.4948C101.078 98.4948 94.776 92.1927 94.776 84.4584C94.776 76.7188 101.078 70.4167 108.818 70.4167C116.552 70.4167 122.854 76.7188 122.854 84.4584C122.854 92.1927 116.578 98.4948 108.818 98.4948ZM108.818 74.6459C103.401 74.6459 99.0052 79.0417 99.0052 84.4584C99.0052 89.8698 103.401 94.2656 108.818 94.2656C114.234 94.2656 118.625 89.8698 118.625 84.4584C118.625 79.0417 114.234 74.6459 108.818 74.6459Z" fill="#53535B"/>
        </g>
        <mask id="mask5_avail_${availableIconUid}" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="102" y="32" width="30" height="28">
        <path d="M102.667 32H131.734V60H102.667V32Z" fill="white"/>
        </mask>
        <g mask="url(#mask5_avail_${availableIconUid})">
        <path d="M129.458 59.0625H104.948C103.786 59.0625 102.818 58.1198 102.818 56.9323V34.5521C102.818 33.3906 103.76 32.4219 104.948 32.4219C106.135 32.4219 107.073 33.3646 107.073 34.5521V54.8333H129.458C130.62 54.8333 131.583 55.7708 131.583 56.9635C131.583 58.151 130.62 59.0625 129.458 59.0625Z" fill="#53535B"/>
        </g>
        <mask id="mask6_avail_${availableIconUid}" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="14" y="2" width="65" height="65">
        <path d="M14.6667 2.79166H78.6667V66.6667H14.6667V2.79166Z" fill="white"/>
        </mask>
        <g mask="url(#mask6_avail_${availableIconUid})">
        <path d="M46.5312 65.9427C29.1198 65.9427 14.974 51.7917 14.974 34.3854C14.974 16.974 29.1198 2.82812 46.5312 2.82812C63.9375 2.82812 78.0885 16.974 78.0885 34.3854C78.0885 51.7917 63.9115 65.9427 46.5312 65.9427ZM46.5312 7.08333C31.4687 7.08333 19.2292 19.3229 19.2292 34.3854C19.2292 49.4427 31.4687 61.6875 46.5312 61.6875C61.5885 61.6875 73.8333 49.4427 73.8333 34.3854C73.8333 19.3229 61.5885 7.08333 46.5312 7.08333Z" fill="#53535B"/>
        </g>
        <path d="M46.5312 17.8333C39.125 17.8333 31.7187 16.8385 25.8333 14.8489C24.7292 14.4635 24.1198 13.2708 24.5052 12.1667C24.8958 11.0625 26.0833 10.4531 27.1875 10.8437C38.0208 14.5156 55.0156 14.5156 65.875 10.8437C66.9792 10.4531 68.1927 11.0625 68.5521 12.1667C68.9115 13.2708 68.3333 14.4896 67.2292 14.8489C61.3125 16.8125 53.9375 17.8333 46.5312 17.8333Z" fill="#53535B"/>
        <path d="M66.5365 58.0677C66.3177 58.0677 66.0937 58.0364 65.849 57.9583C55.0156 54.2812 38.0208 54.2812 27.1614 57.9583C26.0573 58.3437 24.8385 57.7344 24.4792 56.6302C24.0937 55.526 24.7031 54.3073 25.8073 53.9479C37.6042 49.9687 55.401 49.9687 67.1979 53.9479C68.3073 54.3385 68.9115 55.526 68.526 56.6302C68.25 57.5156 67.4219 58.0677 66.5365 58.0677Z" fill="#53535B"/>
        <mask id="mask7_avail_${availableIconUid}" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="36" y="2" width="22" height="65">
        <path d="M36 2.79166H57.3333V66.6667H36V2.79166Z" fill="white"/>
        </mask>
        <g mask="url(#mask7_avail_${availableIconUid})">
        <path d="M46.5312 65.9427C43.3229 65.9427 40.7812 62.5156 39.0156 55.7448C37.5208 50.026 36.6927 42.4271 36.6927 34.3854C36.6927 26.3438 37.5208 18.7708 39.0156 13.026C40.7812 6.25521 43.3229 2.82812 46.5312 2.82812C49.7344 2.82812 52.276 6.25521 54.0469 13.026C55.5417 18.7448 56.3698 26.3438 56.3698 34.3854C56.3698 42.4271 55.5417 50 54.0469 55.7448C52.276 62.5156 49.7344 65.9427 46.5312 65.9427ZM46.5312 7.08333C46.1719 7.14063 44.5156 8.57813 43.0208 14.4896C41.6667 19.8229 40.9219 26.8958 40.9219 34.3854C40.9219 41.875 41.6667 48.9479 43.0208 54.2813C44.5156 60.224 46.1719 61.6302 46.5312 61.6875C46.8906 61.6302 48.5208 60.224 50.0417 54.2813C51.3958 48.9479 52.1406 41.875 52.1406 34.3854C52.1406 26.8958 51.3958 19.8229 50.0417 14.4896C48.5469 8.57813 46.8906 7.14063 46.5312 7.08333Z" fill="#53535B"/>
        </g>
        <path d="M75.9583 36.5104H17.1042C15.9427 36.5104 14.974 35.5729 14.974 34.3854C14.974 33.1979 15.9115 32.2552 17.1042 32.2552H75.9583C77.1198 32.2552 78.0885 33.1979 78.0885 34.3854C78.0885 35.5729 77.1198 36.5104 75.9583 36.5104Z" fill="#53535B"/>
        <mask id="mask8_avail_${availableIconUid}" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="13" y="1" width="66" height="66">
        <path d="M13.6458 1.22916H78.5521V66.1354H13.6458V1.22916Z" fill="white"/>
        </mask>
        <g mask="url(#mask8_avail_${availableIconUid})">
        <mask id="mask9_avail_${availableIconUid}" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="13" y="1" width="66" height="66">
        <path d="M46.099 1.22916C28.1771 1.22916 13.6458 15.7604 13.6458 33.6823C13.6458 51.6094 28.1771 66.1354 46.099 66.1354C64.026 66.1354 78.5521 51.6094 78.5521 33.6823C78.5521 15.7604 64.026 1.22916 46.099 1.22916Z" fill="white"/>
        </mask>
        <g mask="url(#mask9_avail_${availableIconUid})">
        <mask id="mask10_avail_${availableIconUid}" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="13" y="0" width="66" height="67">
        <path d="M78.6667 0H13.3333V66.6667H78.6667V0Z" fill="white"/>
        </mask>
        <g mask="url(#mask10_avail_${availableIconUid})">
        <mask id="mask11_avail_${availableIconUid}" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="13" y="1" width="66" height="66">
        <path d="M13.6458 1.22916H78.5521V66.1354H13.6458V1.22916Z" fill="white"/>
        </mask>
        <g mask="url(#mask11_avail_${availableIconUid})">
        <mask id="mask12_avail_${availableIconUid}" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="13" y="1" width="66" height="66">
        <path d="M46.099 1.22916C28.1771 1.22916 13.6458 15.7604 13.6458 33.6823C13.6458 51.6094 28.1771 66.1354 46.099 66.1354C64.026 66.1354 78.5521 51.6094 78.5521 33.6823C78.5521 15.7604 64.026 1.22916 46.099 1.22916Z" fill="white"/>
        </mask>
        <g mask="url(#mask12_avail_${availableIconUid})">
        <path d="M13.6458 1.22916H78.5521V66.1354H13.6458V1.22916Z" fill="white"/>
        </g>
        </g>
        </g>
        </g>
        </g>
        <mask id="mask13_avail_${availableIconUid}" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="13" y="1" width="66" height="66">
        <path d="M13.7448 1.22916H78.6667V66.6667H13.7448V1.22916Z" fill="white"/>
        </mask>
        <g mask="url(#mask13_avail_${availableIconUid})">
        <path d="M46.0104 1.22916C28.2813 1.22916 13.8594 15.651 13.8594 33.375C15.625 76.026 76.3958 76.0156 78.1563 33.375C78.1563 15.651 63.7344 1.22916 46.0104 1.22916ZM59.3125 46.9375C57.6823 48.5677 55.0469 48.6562 53.3125 47.1458L44.1302 39.151C42.5365 37.7604 41.625 35.75 41.625 33.6406V15.8437C41.7708 10.0729 50.2396 10.0521 50.3906 15.8437V32.7239L59.1354 40.5521C60.9948 42.151 61.0833 45.2396 59.3125 46.9375Z" fill="#FF8200"/>
        </g>
        </g>
        </svg>`;

          availableLabel = document.createElement('div');
          availableLabel.className = 'product_gallery--item-available';
          availableLabel.style.display = 'none';
          availableLabel.innerHTML = availableIconSvg + '<span class="dynamic-delivery-date available-value"></span>';

          // Insert before coming soon label if it exists, otherwise before out of stock label
          var referenceNode = comingSoonLabel || outOfStockLabel;
          if (referenceNode && referenceNode.parentNode) {
            referenceNode.parentNode.insertBefore(availableLabel, referenceNode);
          }
        }
        
        // Create out of stock label if it doesn't exist (only needed if initial variant was in stock)
        if (!outOfStockLabel && (availableLabel || comingSoonLabel)) {
          // NOTE (2026-07-28): used to derive this from ".product_gallery--item-available img"
          // (swapping Available.svg -> Soldout.svg), but the available label no longer renders
          // an <img> (see TEMP block above), so that lookup always failed. Query the sold-out
          // icon directly instead - unaffected by the available-icon change.
          var iconUrl = '';
          var existingOutOfStockImg = document.querySelector('.product_gallery--item-out-of-stock img');
          if (existingOutOfStockImg) {
            iconUrl = existingOutOfStockImg.src;
          }

          outOfStockLabel = document.createElement('div');
          outOfStockLabel.className = 'product_gallery--item-out-of-stock';
          outOfStockLabel.style.display = 'none';
          if (iconUrl) {
            outOfStockLabel.innerHTML = '<img src="' + iconUrl + '" style="width: 45px; height: auto; margin-right: 5px; vertical-align: middle;"><span class="out-of-stock-value">Aktuell nicht lieferbar</span>';
          } else {
            outOfStockLabel.innerHTML = '<span class="out-of-stock-value">Aktuell nicht lieferbar</span>';
          }
              // Insert before coming soon label if it exists, otherwise before available label
          var referenceNode = comingSoonLabel || availableLabel;
          if (referenceNode && referenceNode.parentNode) {
            referenceNode.parentNode.insertBefore(outOfStockLabel, referenceNode);
          }
        }
        
        // Show/hide labels based on availability
        if (variant.available && !hasIncomingDate) {
          // In stock and not preorder - show delivery label
          if (availableLabel && availableLabel.style.display !== 'flex') {
            availableLabel.style.display = 'flex';
          }
          if (outOfStockLabel && outOfStockLabel.style.display !== 'none') {
            outOfStockLabel.style.display = 'none';
          }
          if (comingSoonLabel && comingSoonLabel.style.display !== 'none') {
            comingSoonLabel.style.display = 'none';
          }
        } else if (!variant.available && !hasIncomingDate) {
          // Out of stock and not preorder - show out of stock label
          if (availableLabel && availableLabel.style.display !== 'none') {
            availableLabel.style.display = 'none';
          }
          if (outOfStockLabel && outOfStockLabel.style.display !== 'flex') {
            outOfStockLabel.style.display = 'flex';
          }
          if (comingSoonLabel && comingSoonLabel.style.display !== 'none') {
            comingSoonLabel.style.display = 'none';
          }
        } else if (isPreorder) {
          // Preorder - show coming soon label with variant-specific text
          if (availableLabel && availableLabel.style.display !== 'none') {
            availableLabel.style.display = 'none';
          }
          if (outOfStockLabel && outOfStockLabel.style.display !== 'none') {
            outOfStockLabel.style.display = 'none';
          }
          if (comingSoonLabel) {
            var comingSoonValue = comingSoonLabel.querySelector('.coming-soon-value');
            var currentValue = comingSoonValue ? comingSoonValue.textContent.trim() : '';
            var newValue = variant.incoming_date_single || translations.preorderDefault;

            // Only update if the coming soon date actually changed
            if (comingSoonLabel.style.display !== 'block' || currentValue !== newValue) {
              comingSoonLabel.style.display = 'block';
              if (comingSoonValue) {
                comingSoonValue.textContent = newValue;
              }
            } else {
              // Already showing same value - don't update (preserve translation)
              comingSoonLabel.style.display = 'block';
            }
          }
        } else {
          // Hide all
          if (availableLabel) availableLabel.style.display = 'none';
          if (outOfStockLabel) outOfStockLabel.style.display = 'none';
          if (comingSoonLabel) comingSoonLabel.style.display = 'none';
        }
      }
      
      
      variantInputs.forEach(input => {
        input.addEventListener('change', function(e) {
          if (e.target.dataset.handledBySection) return;
          
          const selectedOptions = [];
          const checkedInputs = item.querySelectorAll('.variant-option-input:checked');
          checkedInputs.forEach(checked => {
            selectedOptions.push(checked.dataset.optionValue);
          });
          
          const variant = findVariantByOptions(selectedOptions);
          
          if (variant) {
            updatePriceDisplay(variant);
            updateMetafields(variant);
            updateDetailedSpecs(variant);
            updateVariantDescription(variant);
            updateDeliveryLabel(variant);
          }
        });
      });
    });
  }
  
  // Initialize on page load
  initializeProductGalleryVariants();
  
  // Reinitialize after filtering (when products are replaced via AJAX)
  const facetMain = document.querySelector('#facet-main');
  if (facetMain) {
    const facetObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          // Products were replaced, reinitialize variant listeners
          initializeProductGalleryVariants();
        }
      });
    });
    
    facetObserver.observe(facetMain, {
      childList: true,
      subtree: false
    });
  }
});

// Cookie Management - Open cookie popup when clicking #manage-cookies link
document.addEventListener('DOMContentLoaded', function() {
  console.log('Cookie management script loaded');

  document.addEventListener('click', function(event) {
    console.log('Click detected on:', event.target);

    const clickedLink = event.target.closest('a');

    if (clickedLink) {
      const href = clickedLink.getAttribute('href') || '';
      console.log('Link clicked with href:', href);

      // Check if link ends with #manage-cookies (handles language URLs too)
      if (href.endsWith('#manage-cookies')) {
        console.log('Manage cookies link detected!');
        event.preventDefault();

        // First, load the Customer Privacy API
        console.log('Loading Shopify Customer Privacy API...');
        window.Shopify.loadFeatures([{
          name: "consent-tracking-api",
          version: "0.1"
        }], (error) => {
          if (error) {
            console.error('Failed to load Customer Privacy API:', error);
            alert('Cookie management system could not be loaded. Please try again.');
            return;
          }

          console.log('Customer Privacy API loaded successfully');

          // Method 1: Try using privacyBanner.showPreferences() (recommended by Shopify docs)
          if (typeof window.privacyBanner !== 'undefined' && window.privacyBanner.showPreferences) {
            console.log('Using privacyBanner.showPreferences() method...');

            window.privacyBanner.showPreferences().then(() => {
              console.log('Privacy preferences modal opened successfully');
            }).catch((err) => {
              console.log('privacyBanner.showPreferences() failed:', err);
              tryAlternativeMethods();
            });
          } else {
            console.log('privacyBanner.showPreferences() not available, trying alternatives...');
            tryAlternativeMethods();
          }

          function tryAlternativeMethods() {
            // Method 2: Try opening existing cookie-bar element
            const cookieBar = document.querySelector('cookie-bar');
            console.log('Cookie bar element found:', cookieBar);

            if (cookieBar) {
              console.log('Opening cookie bar element...');
              cookieBar.open = true;

              // Scroll to the cookie bar
              setTimeout(() => {
                cookieBar.scrollIntoView({ 
                  behavior: 'smooth', 
                  block: 'nearest' 
                });
                console.log('Scrolled to cookie bar');
              }, 100);
            } else {
              // Method 3: Check if we should show a banner and force it
              if (window.Shopify.customerPrivacy.shouldShowBanner && window.Shopify.customerPrivacy.shouldShowBanner()) {
                console.log('Shopify says banner should be shown, but no cookie bar found');
                console.log('This might indicate a theme configuration issue');

                // Show current consent status for debugging
                console.log('Current visitor consent:', window.Shopify.customerPrivacy.currentVisitorConsent());
                console.log('Current region:', window.Shopify.customerPrivacy.getRegion());

                alert('Cookie preferences are available but the interface could not be loaded. Please enable the privacy bar in theme settings.');
              } else {
                console.log('Shopify determined no banner should be shown');
                console.log('Current visitor consent:', window.Shopify.customerPrivacy.currentVisitorConsent());
                console.log('Current region:', window.Shopify.customerPrivacy.getRegion());

                // Show a custom consent management interface
                showCustomConsentInterface();
              }
            }
          }

          function showCustomConsentInterface() {
            console.log('Showing custom consent interface...');

            const currentConsent = window.Shopify.customerPrivacy.currentVisitorConsent();
            const region = window.Shopify.customerPrivacy.getRegion();

            let message = 'Current Cookie Preferences:\n\n';
            message += `Analytics: ${currentConsent.analytics || 'Not set'}\n`;
            message += `Marketing: ${currentConsent.marketing || 'Not set'}\n`;
            message += `Preferences: ${currentConsent.preferences || 'Not set'}\n`;
            message += `Sale of Data: ${currentConsent.sale_of_data || 'Not set'}\n`;
            message += `\nRegion: ${region || 'Unknown'}\n\n`;
            message += 'Would you like to reset your preferences?';

            if (confirm(message)) {
              console.log('User wants to reset preferences');

              // Reset consent (this will likely trigger the banner to show)
              window.Shopify.customerPrivacy.setTrackingConsent({
                analytics: false,
                marketing: false,
                preferences: false
              }, () => {
                console.log('Consent reset, banner should appear');
                // Check if cookie bar appeared after reset
                setTimeout(() => {
                  const newCookieBar = document.querySelector('cookie-bar');
                  if (newCookieBar) {
                    newCookieBar.open = true;
                  }
                }, 500);
              });
            }
          }
        });
      } else {
        console.log('Link does not end with #manage-cookies');
      }
    } else {
      console.log('No link element found in click target');
    }
  });
});

// Dynamic Delivery Date Calculator
(function() {
  function calculateDeliveryMessage() {
    var translations = window.deliveryTranslations || {};
    
    // Check if custom available text is enabled
    if (translations.customAvailableEnabled && translations.customAvailableText) {
      return translations.customAvailableText;
    }
    
    var dayOfWeek, hours;
    
    // Check if test mode is enabled via section settings
    if (window.deliveryTestSettings && window.deliveryTestSettings.enabled) {
      dayOfWeek = parseInt(window.deliveryTestSettings.dayOfWeek);
      hours = parseInt(window.deliveryTestSettings.hour);
    } else {
      // Use store timezone (Europe/Zurich - Swiss time)
      var now = new Date();
      var storeTime = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Zurich' }));
      dayOfWeek = storeTime.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
      hours = storeTime.getHours();
    }
    
    // Get translations from window object
    translations = window.deliveryTranslations || {
      tomorrow: 'Morgen geliefert',
      dayAfterTomorrow: 'Übermorgen geliefert',
      monday: 'Lieferung am Montag',
      tuesday: 'Lieferung am Dienstag'
    };
    
    // Monday to Thursday (1-4)
    if (dayOfWeek >= 1 && dayOfWeek <= 4) {
      if (hours < 13) {
        return translations.tomorrow;
      } else {
        return translations.dayAfterTomorrow;
      }
    }
    // Friday (5)
    else if (dayOfWeek === 5) {
      if (hours < 13) {
        return translations.monday;
      } else {
        return translations.tuesday;
      }
    }
    // Saturday (6) or Sunday (0)
    else {
      return translations.tuesday;
    }
  }
  
  function updateDeliveryDates() {
    var deliveryElements = document.querySelectorAll('.dynamic-delivery-date');
    var message = calculateDeliveryMessage();
    
    deliveryElements.forEach(function(element) {
      element.textContent = message;
    });
  }
  
  function initDeliveryDateCalculator() {
    // Update immediately on page load
    updateDeliveryDates();
    
    // Update every minute to handle time changes
    setInterval(updateDeliveryDates, 60000);
    
    // Update when variant changes
    document.addEventListener('variant:change', function() {
      setTimeout(updateDeliveryDates, 100);
    });
    
    // Watch for dynamically added delivery date elements (quick buy, AJAX content)
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length) {
          // Check if any added nodes contain delivery date elements
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              if (node.classList && node.classList.contains('dynamic-delivery-date')) {
                updateDeliveryDates();
              } else if (node.querySelector && node.querySelector('.dynamic-delivery-date')) {
                updateDeliveryDates();
              }
            }
          });
        }
      });
    });
    
    // Start observing the document for added nodes
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDeliveryDateCalculator);
  } else {
    initDeliveryDateCalculator();
  }
})();

document.addEventListener('DOMContentLoaded', async function () {

  const sections = document.querySelectorAll('.repair-spare-part[data-product-handle]');

  for (const section of sections) {

    const handle = section.dataset.productHandle;
    const intro = section.dataset.intro || '';

    if (!handle) continue;

    try {

      const response = await fetch(`/products/${handle}.js`);
      const product = await response.json();

      const image = product.featured_image;
      const title = product.title;
      const url = `/products/${product.handle}`;

      section.innerHTML = `
        <h2>Passendes Ersatzteil</h2>
        ${intro ? `<p class="repair-spare-part__intro">${intro}</p>` : ''}

        <a href="${url}" class="repair-spare-part__card" target="_blank">

          <div class="repair-spare-part__image-wrap">
            <img src="${image}" alt="${title}">
          </div>

          <div class="repair-spare-part__content">
            <span class="repair-spare-part__label">Original Ersatzteil</span>
            <h3>${title}</h3>
            <span class="repair-spare-part__button">
              Zum Ersatzteil
            </span>
          </div>

        </a>
      `;

    } catch (error) {
      console.error("Ersatzteil konnte nicht geladen werden", error);
    }

  }

});